import React, { Component } from 'react';
import CreateApplicantView from '../../../components/usermanagement/lender/CreateApplicantView';

class CreateApplicant extends Component {
	
	state = {
		formData: {},
	}

	componentDidMount() {        
	} 	  

	render() {
		return (
            <React.Fragment>				
                <CreateApplicantView data={this.state.formData}/>
            </React.Fragment>
		);
	}
}

export default CreateApplicant;